<template>
    <div class="radio-component">
      <div class="block">
        <div v-for="option in component.values" :key="option.value">
          <b-radio
              v-bind:value="value"
              :name="component.key"
              :native-value="option.value"
              v-on:input="$emit('input', $event)"
          >
            {{ option.label }}
          </b-radio>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Radio',
  components: {
  },
  props: {
      component: Object,
      value: String,
      required: Boolean,
  },
  data: function () {
      return {
      }
  },
  computed: {
  },
  methods: {
  },
  mounted(){

  },
}

</script>

<style>

</style>

